import * as logger from "../../../shared/logger";

import PanelLaunch from "../panels/panel-launch";
import ImagePickerModal from "../../form-inputs/image-picker";
import CheckboxPicklist from "../../form-inputs/checkbox-picklist";
import ColorPickerModal from "../../form-inputs/color-picker";
import CascadingPicklist from "../../form-inputs/cascading-picklist";
import FeatureBullets from "../../form-inputs/feature-bullets";
import Lockable from "../../form-inputs/shared/lockable";
import MultiSelectList from "../../form-inputs/custom/react-multi-select";
import PegMeasurements from "../../form-inputs/peg-measurements";
import * as inputs from "../../form-inputs/plain-inputs";
import withSpellcheck from "../../form-inputs/shared/spell-check";
import withValidate from "../../form-inputs/shared/validate";
import AttributeGroupFields from "../../form-inputs/attribute-group-fields";
import ReadOnlyField from "./read-only-field";
import RichText from "../../form-inputs/rich-text";
import SectionLaunch from "../section-launch";
import withSuggestedValue from "../../form-inputs/shared/suggested-value";
import TextareaList from "../../form-inputs/textarea-list";

import ThreeWayCheckbox from "../../form-inputs/boolean";
import { AsyncTypeahead } from "../../form-inputs/typeahead";
import { WithLabel } from "../../form-inputs/components/with-label";
import { YesNoBoolean, Measurement, InputList, NumberList, MeasurementList, Picklist } from "../../form-inputs/inputs";

export const findUpdateKey = (componentType) => {
    switch (componentType) {
        case "Number":
        case "Decimal":
        case "String":
            return "updateOnBlur";
        default:
            return "updateOnChange";
    }
};

export const findAdditionalInfo = (componentType, additionalInfo, roleTaskType) => {
    switch (componentType) {
        case "Picklist":
            if (!additionalInfo || !additionalInfo.picklist) {
                logger.error(`No picklist data found in additionalInfo.picklist for ${componentType}`);

                return {};
            }

            return {
                provider: `/picklists/${additionalInfo.picklist.name}`,
                multiple: additionalInfo.picklist.allowMultipleSelections,
                creatable: additionalInfo.picklist.isCreatable,
            };
        case "DropdownPickList":
        case "ImagePicklist":
        case "MultiDropdownCheckboxPicklist":
        case "MultiDropdownPicklist":
            if (!additionalInfo || !additionalInfo.picklist) {
                logger.error(`No picklist data found in additionalInfo.picklist for ${componentType}`);

                return {};
            }

            return {
                provider: `/picklists/${additionalInfo.picklist.name}`,
            };
        case "AttributeGroup":
        case "VarietyPack":
            if (!additionalInfo || !additionalInfo.parentGroupInfo) {
                logger.error(`No parentGroupInfo data found in additionalInfo.parentGroupInfo for ${componentType}`);

                return {};
            }

            return {
                parentGroupInfo: additionalInfo.parentGroupInfo,
            };
        case "DrugPanel":
            return { text: "Edit", href: "drug" };
        case "EnergyPanel":
            return { text: "Edit", href: "energy" };
        case "GuaranteedAnalysisPanel":
            return { text: "Edit", href: "guaranteed-analysis" };
        case "NutritionPanel":
            return { text: "Edit", href: "nutrition", taskType: roleTaskType };
        case "LightingPanel":
            return { text: "Edit", href: "lighting" };
        case "SupplementPanel":
            return { text: "Edit", href: "supplement" };
        default:
            return {};
    }
};

export const findField = (componentType, readOnly) => {
    if (readOnly) {
        return WithLabel(ReadOnlyField);
    }

    switch (componentType) {
        case "Number":
        case "Decimal":
            return Lockable(withValidate(WithLabel(inputs.NumberInput)));
        case "Measurement":
            return Measurement;
        case "StringList":
            return Lockable(withValidate(withSpellcheck(withSuggestedValue(InputList))));
        case "LinkList":
            return Lockable(withSpellcheck(withSuggestedValue(InputList)));
        case "TextareaList":
            return withSpellcheck(TextareaList);
        case "NumberList":
            return NumberList;
        case "MeasurementList":
            return MeasurementList;
        case "Boolean":
            return withValidate(YesNoBoolean);
        case "BooleanCheckbox":
            return withValidate(WithLabel(ThreeWayCheckbox));
        case "Picklist":
            return withValidate(AsyncTypeahead);
        case "RichText":
            return RichText;
        case "MultiDropdownCheckboxPicklist":
            return CheckboxPicklist;
        case "ColorPicklist":
            return ColorPickerModal;
        case "CascadingPicklist":
            return CascadingPicklist;
        case "DropdownPickList":
            return withValidate(Picklist);
        case "MultiDropdownPicklist":
            // return MultiSelect;
            return MultiSelectList;
        case "ImagePicklist":
            return ImagePickerModal;
        case "AttributeGroup":
            return AttributeGroupFields;
        case "VarietyPack":
            return SectionLaunch;
        case "FeatureBullet":
            return FeatureBullets;
        case "PegMeasurement":
            return PegMeasurements;
        case "DrugPanel":
        case "EnergyPanel":
        case "GuaranteedAnalysisPanel":
        case "LightingPanel":
        case "NutritionPanel":
        case "SupplementPanel":
            return PanelLaunch;
        default:
            return Lockable(withSpellcheck(withValidate(withSuggestedValue(WithLabel(inputs.VariableInput)))));
    }
};
